import types from '@/actions/types';
import useConfig from '@/composables/useConfig';
import useAnalytics from '@/composables/useAnalytics';
import Base from '@/actions/base';

export default class SetVariable extends Base {
  constructor(params) {
    super(params, types.SET_VARIABLE);
  }

  execute() {
    const { setVariables } = useConfig();
    const { trackAction } = useAnalytics();
    trackAction(this);

    return new Promise((resolve) => {
      this.resolve = resolve;
      const { variables } = this.params;
      setVariables(variables);
      resolve();
    });
  }

  stop() {
    this.resolve();
  }
}
